import { create } from "zustand";
import { persist } from "zustand/middleware";

export interface User {
  id: number;
  /** Channel key for the realtime socket (`user-private-channel-{uuid}`).
   *  Optional because not every auth response has been seen to carry it —
   *  features/realtime/channel.ts falls back to `id` and warns. */
  uuid?: string;
  name: string;
  username: string;
  referral_code?: string;
  blue_check?: number;
  profile?: {
    bio?: string | null;
    detail?: string | null;
    links?: string | null;
    cover?: string | null;
    banner?: string | null;
  };
  wallets?: unknown[];
}

interface AuthState {
  user: User | null;
  token: string | null;
  isLoginModalOpen: boolean;
  setUser: (user: User | null) => void;
  setToken: (token: string | null) => void;
  logout: () => void;
  openLoginModal: () => void;
  closeLoginModal: () => void;
}

export const useAuthStore = create<AuthState>()(
  persist(
    (set) => ({
      user: null,
      token: null,
      isLoginModalOpen: false,
      setUser: (user) => set({ user }),
      setToken: (token) => {
        if (token) {
          document.cookie = `token=${token}; path=/; max-age=2592000; SameSite=Lax`; // 30 days
        } else {
          document.cookie = `token=; path=/; max-age=0; SameSite=Lax`;
        }
        set({ token });
      },
      logout: () => {
        document.cookie = `token=; path=/; max-age=0; SameSite=Lax`;
        set({ user: null, token: null });
      },
      openLoginModal: () => set({ isLoginModalOpen: true }),
      closeLoginModal: () => set({ isLoginModalOpen: false }),
    }),
    {
      name: "auth-storage",
      partialize: (state) => ({ user: state.user, token: state.token }),
      skipHydration: true, // We will manually rehydrate
    }
  )
);
